import React from 'react';
import { IconRender, InheritProps } from '../../IconRender';

export function FullscreenIcon(props: InheritProps) {
  return (
    <IconRender
      {...props}
      childrenRender={(color: string) => (
        <>
          <rect x="1" y="1" width="48" height="78" rx="7" fill="#D9D9D9" stroke={color} strokeWidth="4"/>
          <rect x="38" y="8" width="7" height="7" rx="3.5" fill="#343434"/>
          <rect x="22" y="8" width="7" height="7" rx="3.5" fill="#343434"/>
          <rect x="14" y="4" width="7" height="2" rx="1" fill="#343434"/>
          <rect x="6" y="4" width="7" height="2" rx="1" fill="#343434"/>
          <rect x="30" y="8" width="7" height="7" rx="3.5" fill="#343434"/>
          <rect x="22" y="4" width="7" height="2" rx="1" fill="#343434"/>
          <rect x="30" y="4" width="7" height="2" rx="1" fill="#343434"/>
          <rect x="38" y="4" width="7" height="2" rx="1" fill="#343434"/>
          <path d="M32.5551 42.7269C33.2197 43.1154 33.2146 44.0776 32.5459 44.459L21.2615 50.8942C20.5928 51.2755 19.762 50.79 19.7661 50.0202L19.8353 37.03C19.8394 36.2602 20.6753 35.7835 21.3399 36.172L32.5551 42.7269Z" fill="#343434"/>
        </>
      )}
    />
  );
}
